import IdentityPickerExample from "./examples/IdentityPicker.Example";
import IdentityPickerDropdownExample from "./examples/IdentityPickerDropdown.Example";

export default [
    {
        title: "Multi-identity picker",
        code: require("!raw-loader!./examples/IdentityPicker.Example.tsx"),
        component: IdentityPickerExample,
    },
    {
        title: "Single-identity picker",
        code: require("!raw-loader!./examples/IdentityPickerDropdown.Example.tsx"),
        component: IdentityPickerDropdownExample,
    },
];
